import React from 'react';
import Image from 'next/image';
const VideoSection: React.FC = () => {
  return <div className="relative w-full max-w-screen-xl h-[300px] sm:h-[400px] md:h-[500px] lg:h-[656px] flex flex-col justify-center items-center mb-8" data-sentry-component="VideoSection" data-sentry-source-file="video-section.tsx">
      <div className="absolute inset-0">
        <Image src="/assets/images/forever-placeholder.jpg" alt="Blurred background" layout="fill" objectFit="cover" className="rounded-2xl sm:rounded-3xl blur-3xl" quality={100} style={{
        willChange: 'filter'
      }} data-sentry-element="Image" data-sentry-source-file="video-section.tsx" />
      </div>
      <div className="absolute inset-0">
        <video className="w-full h-full object-cover rounded-2xl sm:rounded-3xl" src="/assets/images/video/aloe_mango.mp4" muted loop playsInline autoPlay preload="metadata" />
      </div>
    </div>;
};
export default VideoSection;